import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

const TitleTile = ({ to, title, className }) => pug`
  Link.tile(to=to, className=className)
    .tile__content.tile__content--centered
      h4.tile__title=title
`;

TitleTile.defaultProps = { className: '' };

TitleTile.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default TitleTile;
